var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlights1 = function SvgHighlights1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "highlights1_svg__Group_1128",
    x: 0,
    y: 0,
    viewBox: "0 0 50.1 45.4",
    role: "img"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".highlights1_svg__st1{fill:#616e7d}.highlights1_svg__st2{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "highlights1_svg__Path_8503",
    d: "M21 2.5c6.9-.1 13.4 3.3 17.1 9.1l1-.6C32.7 1.2 19.6-1.5 9.8 5s-12.5 19.6-6 29.4 19.6 12.5 29.4 6c9.2-6.1 12.2-18.1 7-27.8l-1 .6c5.2 9.8 1.5 22-8.3 27.3S8.8 42 3.6 32.2s-1.5-22 8.3-27.3c2.8-1.5 5.9-2.3 9.1-2.4",
    className: "highlights1_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "highlights1_svg__Path_8504",
    d: "M21.1 8.4c4.8-.1 9.3 2.3 12 6.2l4.1-2.5C31.4 3.4 19.6 1 10.8 6.8S-.3 24.5 5.5 33.2s17.6 11.1 26.4 5.3c8.1-5.4 10.9-16.1 6.3-24.8l-4.1 2.5c3.5 7 .7 15.6-6.3 19.2s-15.6.7-19.2-6.3-.7-15.6 6.3-19.2c2-.9 4.1-1.5 6.2-1.5",
    className: "highlights1_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "highlights1_svg__Path_8505",
    d: "M21.2 13.2c3.1 0 6 1.4 7.9 3.9l4.1-2.5c-4.5-6.7-13.6-8.5-20.3-3.9S4.4 24.3 8.9 31s13.6 8.5 20.3 3.9c6.1-4.1 8.2-12.1 4.9-18.7L30 18.7c2.2 4.8.1 10.4-4.7 12.6s-10.4.1-12.6-4.7-.1-10.4 4.7-12.6c1.2-.5 2.5-.8 3.8-.8",
    className: "highlights1_svg__st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "highlights1_svg__Path_8506",
    d: "M21.3 17.9c1.4 0 2.8.6 3.7 1.6l4.1-2.5c-3.1-4.2-9-5.2-13.3-2.1s-5.2 9-2.1 13.3 9 5.2 13.3 2.1c3.6-2.7 4.9-7.5 3-11.6l-4.1 2.5c.1.4.2.9.2 1.4 0 2.6-2.1 4.8-4.7 4.8s-4.8-2.1-4.8-4.7 2.1-4.7 4.7-4.8",
    className: "highlights1_svg__st1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "highlights1_svg__Path_8507",
    d: "m22 21.4 3-1.8c-1.7-2-4.7-2.2-6.7-.4-2 1.7-2.2 4.7-.4 6.7 1.7 2 4.7 2.2 6.7.4 1.4-1.2 2-3.2 1.4-5l-3 1.8c-.4.2-.9.1-1.1-.3v-.1c-.5-.4-.4-1 .1-1.3",
    className: "highlights1_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "highlights1_svg__Path_8508",
    d: "M48.7 10.7q.3.15.6 0l.6-.4c.1-.1.2-.2.1-.3 0-.1-.1-.2-.2-.3L47 8.2l.3-.2c.1 0 .1-.1.1-.2v-.2l-.4-.7c-.1-.1-.3-.2-.4-.1l-.3.2-.1-3.2c0-.1-.1-.2-.2-.3q-.15-.15-.3 0l-.6.4c-.2.1-.3.3-.3.5l.1 3.4-.2.2-.1-3.2q0-.3-.3-.3h-.2l-.6.4c-.2.1-.3.3-.3.5l.1 3.4-.2.1-.1-3.2q0-.3-.3-.3h-.1l-.6.4c-.2.1-.3.3-.3.5l.1 2.9c0 .1-.1.2-.1.3L39.2 11l-1 .6-1 .6-4.1 2.5-4.1 2.5-4 2.4-3 1.8c-.5.3-.6.9-.3 1.3v.1c.2.4.7.5 1.1.3l3-1.8 4.1-2.5 4.1-2.5 4.1-2.5 1-.6 1-.6 2.4-1.5q.15-.15.3 0l2.7 1.4q.3.15.6 0l.6-.4c.1-.1.2-.3.1-.4l-.1-.1-2.9-1.5.2-.1 3.1 1.6q.3.15.6 0l.6-.4c.1-.1.2-.2.2-.3s-.1-.2-.2-.3l-2.9-1.5.2-.1z",
    style: {
      fill: "#aad4c8"
    }
  }));
};
export default SvgHighlights1;